import { createActionsHook } from 'src/lib/sweetState';

import { ConfirmationDialogStore } from './Store';

export const useConfirmationDialogActions = createActionsHook(ConfirmationDialogStore);
